module.exports = __webpack_public_path__ + "static/img/Five-grade-miner.b9c9e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Five-grade-miner.png
// module id = MAVG
// module chunks = 2